import { motion } from 'framer-motion';

const ContractBenefits = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-gradient-to-br from-red via-red-light to-orange-500 rounded-3xl p-10 text-white shadow-2xl relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>
          
          <div className="relative z-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                <i className="ri-gift-line text-3xl"></i>
              </div>
              <h3 className="text-3xl font-bold">ご契約特典</h3>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <p className="text-lg leading-relaxed mb-4">
                勝つ経営に数字の情報は必要です。いくら儲かっているかわからないで、儲かっているいないは判断できません。
              </p>
              <div className="flex items-center gap-3">
                <i className="ri-check-double-line text-2xl"></i>
                <p className="text-lg font-semibold">
                  弥生製品を弥生の会計事務所価格（弥生PAP会員価格）でご提供します
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContractBenefits;
